import { Done } from '@mui/icons-material';
import { HeroSectionWrapper } from '../../styles';
import { HERO_CONTENT, SERVICE_TAGS } from '../../constants';
import {
  HeroContentBox,
  HeroSecondarySubtext,
  TagsContainer,
  TagRow,
  ServiceChip,
  HeroImage,
  HeroTitle,
  HeroSubtext,
  checkIconStyles,
} from './styles';

const chunkIntoRows = (arr) => {
  const out = [];
  for (let i = 0; i < arr.length; i += 3) out.push(arr.slice(i, i + 3));
  return out;
};

const HeroSection = () => {
  return (
    <HeroSectionWrapper>
      <HeroContentBox>
        {/* HeroTitle is an emotion-styled <h2>, so the tag override is `as`. */}
        <HeroTitle as="h1">{HERO_CONTENT.title}</HeroTitle>

        <HeroSubtext>{HERO_CONTENT.subtext}</HeroSubtext>

        <HeroSecondarySubtext>{HERO_CONTENT.sectionLabel}</HeroSecondarySubtext>

        <TagsContainer>
          {chunkIntoRows(SERVICE_TAGS).map((row, index) => (
            <TagRow key={index}>
              {row.map((t) => (
                <ServiceChip
                  key={t}
                  icon={<Done sx={checkIconStyles} />}
                  label={t}
                  variant="filled"
                />
              ))}
            </TagRow>
          ))}
        </TagsContainer>

        <HeroImage
          component="img"
          src={HERO_CONTENT.image}
          alt={HERO_CONTENT.imageAlt}
          loading="lazy"
        />
      </HeroContentBox>
    </HeroSectionWrapper>
  );
};

export default HeroSection;
